import classNames from "classnames";
import React from "react";
import { CheckboxInput } from "@fidget/common/components/form/checkboxInput";
import { TooltipComponent } from "@fidget/common/components/tooltipComponent";
import { intl } from "@fidget/common/i18n/TypedIntl";
import styles from "./listActions.css";

interface Props extends React.PropsWithChildren<{}> {
  onCheckboxChanged(val: boolean): void;
  isChecked: boolean;
  isShowingActions: boolean;
}

export const ListActions = ({
  onCheckboxChanged,
  isShowingActions,
  isChecked,
  children
}: Props) => {
  return (
    <div className={classNames(styles.container, styles["margin-left"])}>
      <TooltipComponent
        text={intl.formatMessage("settings.actions.selectAll")}
        positionPreset="top"
      >
        <CheckboxInput
          id="list-actions-checkbox"
          onChange={onCheckboxChanged}
          value={isChecked}
          noMarginBottom
        />
      </TooltipComponent>
      {isShowingActions && <div className={styles["actions-container"]}>{children}</div>}
    </div>
  );
};

export const ListActionsSection = ({ children }: React.PropsWithChildren<{}>) => {
  return <div className={classNames(styles.section, styles.container)}>{children}</div>;
};
